import classNames from 'classnames';
import * as React from 'react';
import { Input } from '../../../../Forms/Input';
import './style.css';

export interface PostcodeInputProps {
  className?: string;
  invalid?: boolean;
  onChange?: (event: stripe.elements.ElementChangeResponse) => void;
  placeholder?: string;
  ref?: React.RefObject<PostcodeInput>;
  value: string;
}

export interface PostcodeInputState {
  /* empty */
}

export class PostcodeInput extends React.Component<
  PostcodeInputProps,
  PostcodeInputState
> {
  private inputRef = React.createRef<HTMLInputElement>();

  render() {
    const { className, invalid, placeholder, value } = this.props;

    return (
      <Input
        className={classNames(
          {
            'postcode-input': true,
            'postcode-input--invalid': invalid
          },
          className
        )}
        autoComplete="postal-code"
        onChange={this.handleChange}
        placeholder={placeholder}
        forwardRef={this.inputRef}
        value={value}
      />
    );
  }

  public clear = () => {
    if (this.inputRef.current) {
      this.inputRef.current.value = '';
    }
  };

  private handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange } = this.props;

    if (!onChange) {
      return;
    }

    // Provide a change event API that's roughly consistent with the Stripe inputs
    onChange({
      elementType: 'postcode',
      brand: '',
      complete: !!target.value,
      empty: !target.value,
      // Validating postcodes isn't viable, so just treat empty input as invalid,
      // anything else is ok (we'll rely on Stripe rejecting the payment if it's not)
      error: target.value
        ? undefined
        : {
            type: 'card_error',
            charge: '',
            message: 'Postcode is required'
          },
      value: target.value
    });
  };
}

export default PostcodeInput;



// WEBPACK FOOTER //
// ./src/app/components/Premium/Checkout/PaymentForm/PostcodeInput/index.tsx